// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Landing from "../../templates/Landing.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

var heroImg = {
  src: "https://images.instapainting.com/58d4f8a787456fcc228b4597.jpg",
  alt: "A couple on their wedding day embracing in a garden with kids playing around them."
};

var pageTitle = "Custom Wedding Portrait Painting";

var metaDescription = "Turn your wedding photo into a personalized, handmade portrait. View thousands of examples from real customers. Ready to be shipped in about 7-10 days.";

var title = "Order a Personalized Oil Painting of";

var title2 = " Your Wedding Moments";

var description = "Turn your favorite photo into a 100% handmade physical painting from a master artist in oil, watercolor, charcoal, or other mediums. Select a product, upload a photo, and we'll find the best artist to turn your wedding photos into wedding paintings and ship it to your door. Upload your wedding photos to get started today!";

var secondaryContent = {
  title1: "Custom Wedding",
  title2: "Portrait Painting",
  body: "You can browse wedding painting samples from real customers and artists. You’ll see a variety of types of custom wedding portraits that are tailored to your specific preferences and budget. Whether you want a custom wedding painting to celebrate your new marriage or you’re shopping for a gift for a friend or family member, the professional artists at Instapainting can create the best wedding portraits for a timeless keepsake. Work directly with the artist of your choice to ensure you get exactly what you want. Start now by uploading a wedding photo."
};

var mainCta = {
  text: "Upload a Photo",
  link: "/assets"
};

var altCta = {
  text: "Browse Wedding Gallery",
  link: "/gallery/wedding-paintings"
};

var products = [
  {
    title: "Oil Painting",
    src: "https://images.instapainting.com/6222dc1e57765deb068b457a.jpg?fp-z=1.55&fp-x=0.5&fp-y=0.5",
    imageAlt: "",
    sku: "custphotoreal",
    price: 89
  },
  {
    title: "Watercolor",
    src: "https://images.instapainting.com/5ff4089987456f9a1b8b457a.jpg?fp-z=1.2&fp-y=0.55",
    imageAlt: "",
    sku: "custwatercolor",
    price: 89
  },
  {
    title: "Charcoal",
    src: "https://images.instapainting.com/5dfee8eb87456ff9688b456c_w0.jpg?fp-z=1.25&fp-y=0.4&fp-x=0.65",
    imageAlt: "",
    sku: "custcharcoal",
    price: 89
  },
  {
    title: "Pencil Drawing",
    src: "https://images.instapainting.com/5eb8b52487456fdc1d8b459e.jpg?fp-z=1.0&fp-y=0.6",
    imageAlt: "",
    sku: "custpencil",
    price: 89
  },
  {
    title: "Colored-Pencil",
    src: "https://images.instapainting.com/5a33333587456fd4798b456d.jpg?fp-z=1.0",
    imageAlt: "",
    sku: "custpencil",
    price: 89
  }
];

var reviews = [
  {
    name: "Aaron Andress",
    location: "Indianapolis, US",
    review: "The painting was phenomenal! The pictures truly don't do it justice. The artist did an outstanding job and the newlyweds absolutely loved it! Thank you so much!",
    link: "/products/gallery/custphotoreal/59e1989087456fe01a8b45a1/?order=1",
    image: "https://images.instapainting.com/59f321e987456f37028b4568.jpg?fit=crop&crop=focalpoint&fp-y=.55&fp-z=2",
    imageAlt: "Oil painting of a groom kissing the bride on the forehead.",
    date: new Date("11/29/2017")
  },
  {
    name: "Larissa Gavio Binder",
    location: "Boston, US",
    review: "Joy Chen did the most phenomenal job with this wedding oil painting!! The attention to detail is just beautiful and we could not be happier! She was very professional, produced our paining in only a few short weeks and offered us great framing options. I would highly recommend this artist and Instapainting!",
    link: "/products/gallery/custphotoreal/5a522d7887456fe84d8b45a8/?order=1",
    image: "https://images.instapainting.com/5a72775d87456ff66c8b4567_w0.jpg",
    imageAlt: "A couple on their wedding day embracing",
    date: new Date("02/06/2018")
  },
  {
    name: "Tim Walker",
    location: "Tampa, US",
    review: "EXCELLENT work. I was very happy and my new wife was surprised.",
    link: "/products/gallery/custphotoreal/5a19cb5587456f37568b48bd/?order=1",
    image: "https://images.instapainting.com/5a3783f687456f315d8b4570.jpg",
    imageAlt: "",
    date: new Date("01/12/2018")
  }
];

var contentBlocks = [
  {
    title1: "Hand-Painted Portrait of",
    title2: "Your Big Day",
    body: "Tying the knot is a huge occasion and one that you’ll celebrate for years to come! So why not capture the excitement and joy of the day with a handmade custom wedding painting? Our professional artists can take any photo of your special day and transform it into a gorgeous, one-of-a-kind portrait you’ll enjoy looking at daily.\n\nThe best wedding portraits are the ones that convey personal significance and meaning to you. Let our talented artists help you capture the essence and anticipation of your wedding day by working with them one-on-one to achieve the desired look you’re after. Once you select an artist, you’ll get to provide instructions on what you want and provide feedback during the production process. That way, you’ll have peace of mind knowing you’re getting exactly what you paid for."
  },
  {
    title1: "Capture Your Wedding Party",
    title2: "on Canvas",
    body: "A wedding party is truly a special group of people! They have the opportunity to stand by your side while you take the plunge and transition into married life. Typically, they’re made up of close family members and friends who have loved you, supported you, and guided you through your relationship with your significant other. So why wouldn’t you want to recreate special moments with those amazing individuals from your wedding day?\n\nOur professional artists can create cool wedding portraits based on photos of you, your family, and your friends from your special day. You can use these portraits to decorate your home or give away as gifts as you see fit. Most importantly, these beautiful custom wedding portrait paintings will always remind you and your loved ones of that special day when you said “I do.”"
  },
  {
    title1: "Turn a Candid Reception Photo into a",
    title2: "Cherished Memory",
    body: "Remember when your aunt got down and dirty on the dance floor? Or when your little cousin was the most adorable flower girl? Funny wedding portraits can capture some of those cherished memories from your wedding day. Our experienced artists only use the highest quality materials to create a final product that looks and feels priceless. Plus, your handcrafted portrait will withstand the test of time so you can enjoy it for years to come.\n\nIf you have a special moment you want to remember from the day you got hitched, a custom wedding portrait is a creative and fun way to freeze that moment in time and enjoy it over and over again. Upload a candid photo from your reception and have one of our professional artists transform it into a funny wedding portrait that will always have a great story to go with it."
  },
  {
    title1: "",
    title2: "Start by Uploading Your Nuptials Photo Today",
    body: "A personalized wedding portrait is an amazing anniversary gift, Christmas gift, or housewarming present for someone you love. It’s also something you can order for yourself if you just want a new and creative way to enjoy the special moments from your wedding day and cherish the love that you and your spouse have.\n\nIf you’re ready to get started, just select the type of custom wedding portrait you want and upload a photo. Then, write any instructions you have for the artist and submit the order. We’ll follow up with you by helping you choose an available artist that meets your stylistic preferences and budget. Although every project is different, generally, your custom wedding portrait will take less than three weeks to create, review, and ship to you.\n\nReady to get your hand-painted wedding portrait? Start today by uploading a wedding photo."
  }
];

function WeddingPaintingsPage(props) {
  return JsxRuntime.jsx(Landing.LandingPage.make, {
              pageTitle: pageTitle,
              heroImg: heroImg,
              title: title,
              title2: title2,
              description: description,
              metaDescription: metaDescription,
              secondaryContent: secondaryContent,
              mainCta: mainCta,
              altCta: altCta,
              products: products,
              reviews: reviews,
              contentBlocks: contentBlocks
            });
}

var make = WeddingPaintingsPage;

var $$default = WeddingPaintingsPage;

export {
  heroImg ,
  pageTitle ,
  metaDescription ,
  title ,
  title2 ,
  description ,
  secondaryContent ,
  mainCta ,
  altCta ,
  products ,
  reviews ,
  contentBlocks ,
  make ,
  $$default as default,
}
/*  Not a pure module */
